
import BaseArticleCarouselWidget from '../../../../base/components/sidebar/widgets/ArticleCarouselWidget.vue'

export default class ArticleCarouselWidget extends BaseArticleCarouselWidget {}
